import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import { Link } from 'react-router-dom';
import { CheckCircleOutline } from '@mui/icons-material';

function CTASection({ headline, copy, primaryCTA, primaryCTALink, secondaryCTA, secondaryCTALink, trustElements }) {
  return (
    <section className="py-32 bg-gradient-to-br from-blue-600 to-indigo-700 text-white">
      <Container maxWidth="md">
        <div className="flex flex-col items-center text-center">
          <Typography
            variant="h2"
            align="center"
            className="text-4xl lg:text-5xl font-extrabold mb-8 tracking-tight text-white leading-tight"
          >
            {headline}
          </Typography>

          <Typography
            variant="body1"
            align="center"
            className="text-xl lg:text-2xl text-blue-100 mb-16 max-w-3xl mx-auto leading-relaxed"
          >
            {copy}
          </Typography>

          <div className="flex flex-col sm:flex-row gap-6 justify-center w-full mb-16">
            <Button
              component={Link}
              to={primaryCTALink || '/sign-up'}
              variant="contained"
              size="large"
              className="bg-white text-blue-700 hover:bg-gray-50 px-12 py-5 text-xl font-bold shadow-xl rounded-full transition-transform hover:-translate-y-1"
            >
              {primaryCTA}
            </Button>
            <Button
              component={Link}
              to={secondaryCTALink || (secondaryCTA === 'Schedule Demo' ? '/demo' : secondaryCTA === 'View Demo' ? '/demo' : secondaryCTA === 'View Features' ? '/features' : '/pricing')}
              variant="outlined"
              size="large"
              className="border-2 border-white/30 text-white hover:bg-white/10 hover:border-white px-12 py-5 text-xl font-semibold rounded-full"
            >
              {secondaryCTA}
            </Button>
          </div>

          {trustElements && (
            <div className="flex flex-wrap justify-center gap-x-12 gap-y-4 text-base font-medium text-blue-100 opacity-90 mx-auto">
              {trustElements.map((text, i) => (
                <div key={i} className="flex items-center gap-3">
                  <CheckCircleOutline sx={{ fontSize: 20 }} className="text-green-300" />
                  <span>{text}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      </Container>
    </section>
  );
}

export default CTASection;